import React from "react";
import Button from "@mui/material/Button";

interface SnButtonProps {
  text: string;
  onClick: () => void;
  inputRef?: any;
  disabled?: boolean;
  visible?: boolean;
}

export function SnButton({
  text,
  onClick,
  disabled = false,
  inputRef,
  visible = true,
}: SnButtonProps) {
  if (!visible) return null;
  return (
    <Button
      ref={inputRef}
      variant="outlined"
      size="small"
      disabled={disabled}
      onClick={() => {
        if (disabled) return;
        onClick();
      }}
      sx={{
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
        backgroundColor: "white",
        border: "1px solid rgb(0,0,255)",
        borderRadius: "17px",
        padding: "3px 12px",
        marginLeft: "5px",
        color: "rgb(0,0,255)",
        minWidth: "60px",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "rgb(0,0,255)",
          color: "white",
        },
        // '&:active': {
        //   backgroundColor: 'rgb(0,0,255)',
        //   color: 'white',
        // },
        // '&:focus': {
        //   backgroundColor: 'rgb(0,0,255)',
        //   color: 'white',
        // },
      }}
    >
      {text}
    </Button>
  );
}

export default React.memo(SnButton);
